import React from 'react'
import HeroImage1 from '../images/hero-images/pragicts-ourshare-banner-1.jpg'
import HeroImage2 from '../images/hero-images/pragicts-ourshare-banner-2.jpg'
import HeroImage3 from '../images/hero-images/pragicts-ourshare-banner-3.jpg'
import HeroImage4 from '../images/hero-images/pragicts-ourshare-banner-4.jpg'


const slides = [
    {
        id: 1,
        image: HeroImage1,
        mainText: 'SERVICE TO MANKIND IS  <br /> <span>SERVICE TO GOD  </span>',
         subText: 'Prophet Muhammad, PBUH'
       ,
       
    },
    {
        id: 2,
        image: HeroImage3,
        mainText: 'THOUSANDS OF CANDLES<br /> CAN BE LIGHTED FROM A SINGLE CANDLE.<br /> <span>HAPPINESS NEVER DECREASES BY BEING SHARED</span>', 
        subText: 'Gautama Buddha'
    },
    {
        id: 3,
        image: HeroImage2,
        mainText: 'DO TO OTHERS AS YOU WOULD<br /><span>HAVE THEM DO TO YOU</span>',
        subText: 'Bible, Luke 6:31',
    },
  
    {
        id: 4,
        image: HeroImage4,
        mainText: 'NO ONE WHO DOES GOOD WORK<br /> WILL EVER COME TO A BAD END,<br /><span>EITHER HERE OR IN THE WORLD TO COME</span>',
        subText: 'Bhagavad Gita'
    },
    
    
]

const HeroSlides = () => {

    return (
        <div className="hero-wrap" id="sec1" data-scrollax-parent="true">
            <div className="slider-carousel-wrap full-height fullscreen-slider-wrap">
                <div className="fullscreen-slider full-height cur_carousel-slider-container fl-wrap" data-slick='{"autoplay": true, "autoplaySpeed": 4000 , "pauseOnHover": false}'>
                {slides.map(slide => (
                    <div key={slide.image} className="fullscreen-slider-item full-height fl-wrap">
                        <div className="bg par-elem hero-bg"  data-bg={slide.image}></div>
                        <div className="overlay"></div>
                        <div className="half-hero-wrap">
                            <h1 dangerouslySetInnerHTML={{ __html: slide.mainText }}></h1>
                            <h4>{slide.subText}</h4>
                            <div className="clearfix"></div>
                            {/* <a href={slide.action.link} className="custom-scroll-link btn float-btn flat-btn color-btn mar-top">Let's Start</a> */}
                        </div>
                    </div>
                ))}
                </div>
                <div className="sp-cont   sp-cont-prev"><i className="fal fa-arrow-left"></i></div>
                <div className="sp-cont   sp-cont-next"><i className="fal fa-arrow-right"></i></div>
                <div className="fullscreenslider-counter"></div>
            </div>
            <div className="hero-decor-numb">
                <span>6.9149106  </span><span>79.9105932 </span>
                <a href="https://g.page/PragICTS?share" target="_blank" className="hero-decor-numb-tooltip">Based In Colombo, Sri Lanka</a>
            </div>
        </div>
    )
}

export default HeroSlides
